module.exports = __webpack_public_path__ + "static/img/touX_pi00c@2x.4a1c37d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/operation/touX_pi00c@2x.png
// module id = rvjd
// module chunks = 90